import { useId } from 'react';
import { Checkbox } from '../../components/Checkbox';
import { TextArea } from '../../components/TextArea';
import { Card, CardTitle, HeaderRow, NotesArea } from './BookingNotesCard.styles';
import type { BookingNotesCardProps } from './BookingNotesCard.types';

export function BookingNotesCard({
  checked,
  onToggle,
  value,
  onChange,
  labels = {},
}: BookingNotesCardProps) {
  const {
    title = 'Add any notes',
    placeholder = "Anything you'd like us to know?",
    toggleAriaLabel,
  } = labels;

  const notesId = useId();

  return (
    <Card>
      <HeaderRow>
        <CardTitle>{title}</CardTitle>
        <Checkbox
          checked={checked}
          onChange={onToggle}
          aria-label={toggleAriaLabel ?? title}
          aria-expanded={checked}
          aria-controls={checked ? notesId : undefined}
        />
      </HeaderRow>
      {checked && (
        <NotesArea>
          <TextArea
            id={notesId}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            placeholder={placeholder}
            aria-label={placeholder}
          />
        </NotesArea>
      )}
    </Card>
  );
}
